"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyRandomizationUploadStatus = exports.StudyRandomCode = exports.StudyRandomizationUpload = exports.StudyRandomizationUploadResultCode = exports.StudyRandomizationStratificationEssential = exports.StudyRandomizationStratification = exports.StudyRandomGroupEssential = exports.StudyRandomGroup = exports.StudyRandomization = exports.StudyRandomizationIsolated = exports.StudyRandomizationMethod = void 0;
var StudyRandomizationMethod;
(function (StudyRandomizationMethod) {
    StudyRandomizationMethod["StratifiedBlockUpload"] = "STRATIFIED_BLOCK_UPLOAD";
    StudyRandomizationMethod["StratifiedBlockSysGen"] = "STRATIFIED_BLOCK_SYSGEN";
})(StudyRandomizationMethod = exports.StudyRandomizationMethod || (exports.StudyRandomizationMethod = {}));
var StudyRandomizationIsolated;
(function (StudyRandomizationIsolated) {
    StudyRandomizationIsolated["Study"] = "STUDY";
    StudyRandomizationIsolated["Site"] = "SITE";
})(StudyRandomizationIsolated = exports.StudyRandomizationIsolated || (exports.StudyRandomizationIsolated = {}));
// NOTE: 수정할 때 maven-rest StudyRandomization 쪽도 함꼐 수정해야함.
class StudyRandomization {
}
exports.StudyRandomization = StudyRandomization;
// NOTE:  수정할 경우 maven-rest 쪽도 같이 수정해야함
class StudyRandomGroup {
}
exports.StudyRandomGroup = StudyRandomGroup;
class StudyRandomGroupEssential {
}
exports.StudyRandomGroupEssential = StudyRandomGroupEssential;
class StudyRandomizationStratification {
}
exports.StudyRandomizationStratification = StudyRandomizationStratification;
class StudyRandomizationStratificationEssential {
}
exports.StudyRandomizationStratificationEssential = StudyRandomizationStratificationEssential;
var StudyRandomizationUploadResultCode;
(function (StudyRandomizationUploadResultCode) {
    StudyRandomizationUploadResultCode["Done"] = "DONE";
    StudyRandomizationUploadResultCode["StudyDisabled"] = "STUDY_DISABLED";
    StudyRandomizationUploadResultCode["StudyLocked"] = "STUDY_LOCKED";
    StudyRandomizationUploadResultCode["RandomizationNotSetup"] = "RANDOMIZATION_NOT_SETUP";
    StudyRandomizationUploadResultCode["SiteNotExist"] = "SITE_NOT_EXIST";
    StudyRandomizationUploadResultCode["FileNotExist"] = "FILE_NOT_EXIST";
    StudyRandomizationUploadResultCode["SiteCodeMissing"] = "SITE_CODE_MISSING";
    StudyRandomizationUploadResultCode["SiteCodeInvalid"] = "SITE_CODE_INVALID";
    StudyRandomizationUploadResultCode["SiteCodeOnlyPossibleAll"] = "SITE_CODE_ONLY_POSSIBLE_ALL";
    StudyRandomizationUploadResultCode["SiteCodeOnlyPossibleSite"] = "SITE_CODE_ONLY_POSSIBLE_SITE";
    StudyRandomizationUploadResultCode["StratificationMissing"] = "STRATIFICATION_MISSING";
    StudyRandomizationUploadResultCode["SeqMissing"] = "SEQ_MISSING";
    StudyRandomizationUploadResultCode["SiteStratificationSeqDuplicated"] = "SITE_STRATIFICATION_SEQ_DUPLICATED";
    StudyRandomizationUploadResultCode["SeqInvalid"] = "SEQ_INVALID";
    StudyRandomizationUploadResultCode["RandomGroupMissing"] = "RANDOM_GROUP_MISSING";
    StudyRandomizationUploadResultCode["RandomGroupTooLong"] = "RANDOM_TOO_LONG";
    StudyRandomizationUploadResultCode["RandomCodeMissing"] = "RANDOM_CODE_MISSING";
    StudyRandomizationUploadResultCode["RandomCodeTooLong"] = "RANDOM_CODE_TOO_LONG";
    StudyRandomizationUploadResultCode["RandomCodeDuplicated"] = "RANDOM_CODE_DUPLICATED";
    StudyRandomizationUploadResultCode["RandomCodeCannotUpdateAfterRandomCodeAssigned"] = "RANDOM_CODE_CANNOT_UPDATE_AFTER_RANDOM_CODE_ASSIGNED";
    StudyRandomizationUploadResultCode["DescriptionTooLong"] = "DESC_TOO_LONG";
    StudyRandomizationUploadResultCode["StratificationInvalid"] = "STRATIFICATION_INVALID";
    StudyRandomizationUploadResultCode["RandomGroupInvalid"] = "RANDOM_GROUP_INALID";
    StudyRandomizationUploadResultCode["ActiveInvalid"] = "ACTIVE_INVALID";
    StudyRandomizationUploadResultCode["RandomCodeCannotReactivated"] = "RANDOM_CODE_CANNOT_REACTIVATED";
    StudyRandomizationUploadResultCode["UnexpectedError"] = "UNEXPECTED_ERROR";
})(StudyRandomizationUploadResultCode = exports.StudyRandomizationUploadResultCode || (exports.StudyRandomizationUploadResultCode = {}));
class StudyRandomizationUpload {
}
exports.StudyRandomizationUpload = StudyRandomizationUpload;
class StudyRandomCode {
}
exports.StudyRandomCode = StudyRandomCode;
var StudyRandomizationUploadStatus;
(function (StudyRandomizationUploadStatus) {
    StudyRandomizationUploadStatus["Wait"] = "WAIT";
    StudyRandomizationUploadStatus["Processing"] = "PROCESSING";
    StudyRandomizationUploadStatus["Processed"] = "PROCESSED";
    StudyRandomizationUploadStatus["Failed"] = "FAILED";
})(StudyRandomizationUploadStatus = exports.StudyRandomizationUploadStatus || (exports.StudyRandomizationUploadStatus = {}));
//# sourceMappingURL=studyRandomization.js.map